import { useEffect } from '../../InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties,systemConfiguration,includeScripts, includeBootstrapCss, includeBundleBootstrapCss } from '../../CommonImports';
import './../css/GRecentJobs.css';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import GHeader from "./GHeader";
import GFooter from "./GFooter";
import GJobsHubMenu from "./GJobsHubMenu";
import GSingleSider from './GSingleSider';
import GSingleHeader from './GSingleHeader';
import GJobSingleInfo from './GJobSingleInfo';
import GJobSingleRecentjobs from './GJobSingleRecentjobs';
import GSignImg from './GSignImg';

function GJobSingle() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <GHeader />
            <GJobsHubMenu />
            <GSingleHeader />
            <section className="section-box mt-50">
                <div className="container">
                    <div className="row">
                            <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                                    <GJobSingleInfo/>
                                    <GJobSingleRecentjobs />
                            </div>
                            <GSingleSider />
                    </div>
                </div>
            </section>

            <section className="section-box my-5">
                <GSignImg/>
            </section>
            <GFooter />
        </div>
    );
}
export default GJobSingle;